import { buildFieldLayoutFromSet } from "../defaults/fieldLayoutUtils";
import { applyFieldConstraints } from "./applySystemFieldConstraints";

const sortByOrder = (items = []) =>
  [...items].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
const resolveFieldSet = (sectionConfig, config) => {
  const setId = sectionConfig?.fieldSet;
  if (!setId) return null;
  return config?.fieldSets?.[setId] || null;
};

export const resolveSubFieldLayouts = (sectionConfig, config, ruleContext) => {
  const refs = sectionConfig?.subFieldSets;
  if (!refs || typeof refs !== "object") return {};
  return Object.entries(refs).reduce((acc, [key, setId]) => {
    acc[key] = resolveSectionFieldLayout({ fieldSet: setId }, config, ruleContext);
    return acc;
  }, {});
};

export const resolveSectionFieldLayout = (
  sectionConfig,
  config = {},
  ruleContext = {},
) => {
  const fieldSet = resolveFieldSet(sectionConfig, config);
  const rawFields = sectionConfig?.fields?.length
    ? sectionConfig.fields
    : fieldSet?.fields || [];
  const rawColumns = sectionConfig?.tableColumns?.length
    ? sectionConfig.tableColumns
    : fieldSet?.tableColumns || [];

  const fieldSetId = sectionConfig?.fieldSet ?? null;
  const constrained = applyFieldConstraints(rawFields, fieldSetId, rawColumns);

  const fields = sortByOrder(constrained.fields).filter((field) => field.enabled !== false);

  const tableColumns = sortByOrder(constrained.tableColumns).filter(
    (column) => column.enabled !== false,
  );

  const layout = buildFieldLayoutFromSet({ fields, tableColumns }, ruleContext);
  return {
    ...layout,
    pattern: fieldSet?.pattern ?? sectionConfig?.pattern ?? null,
    fieldSetId: sectionConfig?.fieldSet ?? null,
  };
};